// =====================================
// NO EDITAR ESTE ARCHIVO DIRECTO
// COMPILADO 2026-07-24 15:09:30
// =====================================

enum USERS{
	_ID = 1,
	VIEW_USERS = 1000,
	EDIT_ACCESS = 1003,
	SEARCH_USERS = 1004,
}
enum PROSPECTS{
	_ID = 2,
	VIEW_PROSPECTS = 2000,
	CREATE_PROSPECTS = 2001,
	EDIT_PROSPECTS = 2002,
	DELETE_PROSPECTS = 2090,
}
enum PROMOTERS{
	_ID = 3,
	VIEW_PROMOTERS = 3000,
	VIEW_EVENTS = 3001,
	EDIT_PROMOTERS = 3002,
	DELETE_PROMOTERS = 3090,
}
enum FORMS{
	_ID = 4,
	VIEW_FORMS = 4000,
	CREATE_FORMS = 4001,
	EDIT_FORMS = 4002,
	DELETE_FORMS = 4090,
}
enum ACTIVITIES{
	_ID = 5,
	VIEW_ACTIVITY_TYPES = 5000,
	CREATE_ACTIVITY_TYPES = 5001,
	EDIT_ACTIVITY_TYPES = 5002,
	DELETE_ACTIVITY_TYPES = 5090,
}
const ACCESS_ARRAY = [
	{
		id: 1,
		varname: 'USERS',
		name: 'Usuarios',
		access: [
			{ id: 1000, name: 'Ver usuarios' },
			{ id: 1003, name: 'Editar permisos' },
			{ id: 1004, name: 'Buscar usuarios' },
		],
	},
	{
		id: 2,
		varname: 'PROSPECTS',
		name: 'Prospectos',
		access: [
			{ id: 2000, name: 'Ver prospectos' },
			{ id: 2001, name: 'Crear prospectos' },
			{ id: 2002, name: 'Editar prospectos' },
			{ id: 2090, name: 'Eliminar prospectos' },
		],
	},
	{
		id: 3,
		varname: 'PROMOTERS',
		name: 'Promotores',
		access: [
			{ id: 3000, name: 'Ver promotores' },
			{ id: 3001, name: 'Ver eventos' },
			{ id: 3002, name: 'Editar promotores' },
			{ id: 3090, name: 'Eliminar promotores' },
		],
	},
	{
		id: 4,
		varname: 'FORMS',
		name: 'Formularios',
		access: [
			{ id: 4000, name: 'Ver formularios' },
			{ id: 4001, name: 'Crear formularios' },
			{ id: 4002, name: 'Editar formularios' },
			{ id: 4090, name: 'Eliminar formularios' },
		],
	},
	{
		id: 5,
		varname: 'ACTIVITIES',
		name: 'Actividades',
		access: [
			{ id: 5000, name: 'Ver tipos de actividad' },
			{ id: 5001, name: 'Crear tipos de actividad' },
			{ id: 5002, name: 'Editar tipos de actividad' },
			{ id: 5090, name: 'Eliminar tipos de actividad' },
		],
	},
]

export default {
	ACCESS_ARRAY,
	USERS,
	PROSPECTS,
	PROMOTERS,
	FORMS,
	ACTIVITIES,
}